import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XpoLtlBaseCacheService } from '@xpo-ltl/ngx-ltl';
import { ClaimsApiService, ListExaminerClaimsQuery, ListExaminerClaimsResp } from '@xpo-ltl/sdk-claims';
import * as _ from 'lodash';
import { AssignedClaimsCacheParams } from '../../interfaces/assigned-claims-cache-params.interface';
import { ApiRequest } from '@xpo-ltl/data-api';

@Injectable()
export class ListExaminerClaimsCacheService extends XpoLtlBaseCacheService<AssignedClaimsCacheParams, ListExaminerClaimsResp> {
  constructor(private claimsApiService: ClaimsApiService) {
    super();
  }

  protected getKeyFromParams(params: AssignedClaimsCacheParams): string {
    return `${params.index}`;
  }

  protected requestData(params: AssignedClaimsCacheParams): Observable<ListExaminerClaimsResp> {
    const request = new ListExaminerClaimsQuery();
    _.assign(request, _.pick(params, _.keys(request)));
    request.examinerEmployeeId = params.employeeId;

    return this.claimsApiService.listExaminerClaims(request, { ...ApiRequest.defaultDataOptions, toastOnError: false });
  }
}
